var moduleMap = {
	"./RichSearch-client": function() {
		return __webpack_require__.e(178).then(function() { return function() { return (__webpack_require__(1089)); }; });
	},
	"./RichSearch.global-client": function() {
		return __webpack_require__.e(827).then(function() { return function() { return (__webpack_require__(7827)); }; });
	},
	"./RichSearch.inline-client": function() {
		return __webpack_require__.e(593).then(function() { return function() { return (__webpack_require__(2303)); }; });
	},
	"./RichSearchFallback-client": function() {
		return __webpack_require__.e(512).then(function() { return function() { return (__webpack_require__(5744)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "react17"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});